import { render, staticRenderFns } from "./suggest_prod.vue?vue&type=template&id=29d3b019&scoped=true"
import script from "./suggest_prod.vue?vue&type=script&lang=js"
export * from "./suggest_prod.vue?vue&type=script&lang=js"
import style0 from "./suggest_prod.vue?vue&type=style&index=0&id=29d3b019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d3b019",
  null
  
)

export default component.exports